import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// components
import Iconify from '../../../components/iconify';
import api from '../../../api';
import { loadingStartAction } from 'src/redux/actions/loadingActions';

// ----------------------------------------------------------------------

export default function ShareWithFriends({ data, getAllSettings }) {
  const dispatch = useDispatch();
  // States for input fields

  const [shareUrl, setShareUrl] = useState(data?.socialMediaUrls?.share_msg || '');
  const [shareMsg, setShareMsg] = useState(data?.socialMediaUrls?.share_url) || '';

  const handleSave = async () => {
    let reqBody = {
      socialMediaUrls: {
        share_msg: shareMsg,
        share_url: shareUrl,
      },
    };

    dispatch(loadingStartAction());
    await api.put('/settings', reqBody);
    getAllSettings();
  };

  return (
    <>
      <Stack spacing={3}>
        <TextField name="app_link" label="App Link" value={shareUrl} onChange={(e) => setShareUrl(e.target.value)} />
        <TextField
          name="shareMsg"
          label="Share Message"
          value={shareMsg}
          onChange={(e) => setShareMsg(e.target.value)}
        />
      </Stack>

      <br />
      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleSave}>
        SAVE
      </LoadingButton>
    </>
  );
}
